import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import AutoFocus from '../AutoFocus'

import panelStyle from 'Styles/panel.css'
import style from './style.css'

import closeImg from 'Assets/x-icon-gray.svg'

function getAnswer (curCard) {
  let answer
  if (curCard.testTerm) {
    answer = curCard.userAnswer
  } else {
    answer = curCard.choices[curCard.userAnswerIndex]
  }
  return answer
}

function getFeedback (curCard) {
  let feedback
  if (curCard.testTerm) {
    feedback = "If you think you've entered the right answer, check your spelling or try a hint!"
  } else {
    feedback = curCard.choices_fb[curCard.userAnswerIndex]
  }
  return feedback
}

export default function IncorrectModal (props) {
  const answer = getAnswer(props.curCard)
  const feedback = getFeedback(props.curCard)
  return (
    <div
      data-test-id="IncorrectModal"
      className={classnames(panelStyle.large, style.container)}
    >
      <button
        data-test-id="incorrectAnswerModalCloseBtn"
        onClick={props.onHide}
        className={classnames(style.hideModal)}
      >
        <img
          src={closeImg}
          alt="Close this feedback"
        />
      </button>

      <AutoFocus check={answer}>
        <h2 className={style.incorrect}>
          {props.curCard.feedbackIntro}
        </h2>
        <p className={style.textInfoModal}>The correct answer is not</p>
        <h2
          data-test-id="incorrectAnswerModalAnswer"
          className={style.textAnswerModal}
          dangerouslySetInnerHTML={{ __html: answer }}
        />
      </AutoFocus>
      <h3
        data-test-id="incorrectAnswerModalHint"
        className={style.textInfoModal}
        dangerouslySetInnerHTML={{ __html: feedback }}
      />
      <div className={style.challenge}>
        <button
          onClick={props.onChallenge}
          className={classnames('btn-cdl-secondary', style.challenge)}
          data-test-id="showAnswerModalBtn"
        >
          Report an error with this Question
        </button>
      </div>
    </div>
  )
}

IncorrectModal.propTypes = {
  curCard: PropTypes.object.isRequired,
  onHide: PropTypes.func.isRequired,
  onChallenge: PropTypes.func.isRequired
}
